module.exports = __webpack_public_path__ + "static/media/baby-cereja.7585f792.jpg";